import { render, staticRenderFns } from "./WorkflowReviewOverview.vue?vue&type=template&id=4ab3e51c&scoped=true&"
import script from "./WorkflowReviewOverview.vue?vue&type=script&lang=js&"
export * from "./WorkflowReviewOverview.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowReviewOverview.vue?vue&type=style&index=0&id=4ab3e51c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab3e51c",
  null
  
)

export default component.exports